"use client";

import { ModalFooter as HeroModalFooter } from "@heroui/react";
import { cn } from "../../lib/utils";

export const ModalFooter = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroModalFooter>) => {
  return (
    <HeroModalFooter
      className={cn(
        "max-sm:[&_button]:h-12 max-sm:[&_button]:min-w-24 max-sm:[&_button]:gap-3 max-sm:[&_button]:rounded-large max-sm:[&_button]:px-6 max-sm:[&_button]:text-medium",
        className,
      )}
      {...props}
    />
  );
};
